import _ from "lodash";
/**--internal-- */
import client from "lib/apolloClient/client";
import update from "immutability-helper";

/**--relative-- */
import { getGlobalConstantsQuery } from "./OperationalDaysAndTimeZoneQueries";

export const getGlobalConstantsFromCache = variables => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getGlobalConstantsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const writeGlobalConstantsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getGlobalConstantsQuery,
      variables,
      data: { node: data },
    });
  } catch (e) {
    console.error(e);
  }
};

export const updateGlobalConstantsInCache = ({
  variables,
  globalConstantName,
  globalConstantValue,
}) => {
  const data = getGlobalConstantsFromCache(variables);

  const updatedData = update(data, {
    globalConstants: globalConstants => {
      return _.map(globalConstants, ({ name, ...rest }) => {
        return name === globalConstantName
          ? { ...rest, name, value: globalConstantValue }
          : { ...rest, name };
      });
    },
  });

  writeGlobalConstantsToCache({ variables, data: updatedData });
};
